<script>
   import Layout from '../../layouts/main'
   import PageHeader from '@/components/page-header'
   import appConfig from "@/app.config";
    
   export default {
      page: {
         title: "Profile",
         meta: [
            {
               name: "description",
               content: appConfig.description,
            },
         ],
      },
      components: { Layout, PageHeader },
      data() {
         return {
            title: "Profile",
            items: [
               {
                  text: "Profile",
                  href: "/profile",
               },                
               
               {
                  text: "Profile",
                  active: true,
               },                     
            ],

            store_station: {
               location: '',
            },
            
            marker: { position: { lat: null, lng: null } },
            center: { lat: null, lng: null },
            current_place: null,

            mapOptions: {
               disableDefaultUI: true,
            }, 

            store: {},
            no_of_orders: 0,

            errors: {},
            token: '',
show_password: false,
            show_confirm_password: false,

            password: '',
            password_confirmation: '',     

         };
      },
      mounted() {
    
      },

      created() {
         this.fetchStore();
      },

      methods: {
         showModal(modal) {
            this.$refs[modal].show();
         },

         hideModal(modal) {
            this.$refs[modal].hide();
         },  

         fetchStore() {

            this.getToken();
            let url = "store/store/profile/view";          
            this.loading = true;
            
            this.$axios
               .get(url, { headers: { Authorization: "Bearer " + this.token } })
               .then((res) => {
                  if(res.status == 200) {
                     var responseData = res.data.data;
                     console.log(responseData);
                     
                     this.store = responseData.store_detail[0];
                     this.no_of_orders = responseData.no_of_orders;
                     
                     if(responseData.no_of_orders) {
                        this.no_of_orders = responseData.no_of_orders;
                     }

                     this.marker.position.lat = parseFloat(this.store.latitude);
                  this.marker.position.lng = parseFloat(this.store.longitude);

                  this.center.lat = parseFloat(this.store.latitude);
                  this.center.lng = parseFloat(this.store.longitude);

                  } else {
                     this.$swal("", "Something went wrong", "error");
                  }
               
            })
            .catch((error) => {
               if (error.response) {
                  if(error.response.status == 422) {               
                     if (error.response.data) {
                        this.errors = error.response.data.message;
                     } 
                     this.$swal("", error.response.statusText, "error");
                     
                  } else if(error.response.status == 500) {
                     this.$swal("", error.response.statusText, "error");

                  } else if(error.response.status == 401) {
                     this.$swal("", error.response.statusText, "error");
                     this.$router.push({ name: "login" });
                     
                  } else {
                     this.$swal("", "Something went wrong", "error");
                  }
               } else {
                  this.$swal("", error.message, "error");
               }
            })
            .finally(() => (this.loading = false));
         }, 

         getToken() {
            if (localStorage.getItem('sigofish_store')) {
               var sigofish_store =  JSON.parse(localStorage.getItem('sigofish_store'));
               if(sigofish_store.token) {
                  this.token = sigofish_store.token;
               } else {
                  this.$swal("", "Failed to fetch token, please login again", "error");
                  this.$router.push({ name: "login" });
               }
               
            } else {
               this.$swal("", "Session expired, please login again", "error");
               this.$router.push({ name: "login" });
            }
         }, 
 togglePassword() {
            if(this.show_password == false) {
               this.show_password = true;
            } else {
               this.show_password = false;
            }
         },

         toggleCurrentPassword() {
            if(this.show_current_password == false) {
               this.show_current_password = true;
            } else {
               this.show_current_password = false;
            }
         },

         toggleConfirmPassword() {
            if(this.show_confirm_password == false) {
               this.show_confirm_password = true;
            } else {
               this.show_confirm_password = false;
            }
         },

        
         updatePassword() {
            this.getToken();           
            
            const config = {
               headers: {
                  "Content-type": "multipart/form-data",
                  "Accept": "application/json",
                  "Authorization": "Bearer " + this.token,
               },
            };

            let url = "store/store/change_password";

            let formData = new FormData();
            formData.append("id", this.store.id); 
            formData.append("password", this.password); 
            formData.append("password_confirmation", this.password_confirmation); 
            
           
            this.$axios
            .post(url, formData, config)
            .then((res) => {
               if(res.status == 200) {
                  this.$swal("", res.data.message, "success");
                  this.hideModal('password-modal');
               } else {
                  this.$swal("", "Something went wrong", "error");
               }
            })
            .catch((error) => {
               if (error.response) {
                  if(error.response.status == 422) {               
                     if (error.response.data) {
                        this.errors = error.response.data.message;
                     } 
                     this.$swal("", error.response.statusText, "error");
                     
                  } else if(error.response.status == 500) {
                     this.$swal("", error.response.statusText, "error");

                  } else if(error.response.status == 401) {
                     this.$swal("", error.response.statusText, "error");
                     this.$router.push({ name: "login" });
                     
                  } else {
                     this.$swal("", "Something went wrong", "error");
                  }
               } else {
                  this.$swal("", error.message, "error");
               }
            })
            .finally(() => (this.loading = false));
         }, 

         clearForm() {
            this.password = '';
            this.password_confirmation = '';
            this.errors = {};
         },   
      }
   }
</script>
    
<template>
   <Layout>
      <PageHeader :title="title" :items="items" />
      <div class="row">
         <div class="col-12">
            <div class="card">
               <div class="card-body">
                  <!-- <h4 class="card-title"></h4>
                  <p class="card-title-desc"></p> -->

                  <!----- top button area starts---->
                  <div class="row mb-3">
                     <div class="col-12">

                        <a href="#" @click.prevent="$router.go(-1)" class="btn btn-primary float-end"><i class='bx bx-chevrons-left'></i> Back</a>
                        
                     </div>
                  </div>
                  <!----- top button area ends---->                  

                  <!---- Details starts -------->
                  <div class="row">
                     <div class=" col-lg-5 col-md-5">
                        <div class="card overflow-hidden">
                           <div class="bg-soft bg-primary">
                              <div class="row m-0">
                                 <div class="col-7">
                                 
                                 </div>
                                 <div class="col-5 align-self-end">
                                    <img src="@/assets/images/profile-img.png" alt class="img-fluid" />
                                 </div>
                              </div>
                           </div>
                           <div class="card-body pt-2">
                              <div class="row">
                                 <!-- <div class="col-sm-4">
                                    <div class="avatar-md profile-user-wid mb-1">
                                       <img src="@/assets/images/users/marine.png"
                                       alt
                                       class="img-thumbnail rounded"
                                       />
                                    </div>
                                    
                                 </div> -->
                                <div class="col-sm-8 align-self-center">
                                    <h5 class="font-size-26">
                                       {{store.name}}
                                    </h5>
                                    <p class="font-size-15">
                                       {{store.contact_name}} <br>
                                    
                                       <i class="bx bx-phone me-1 text-primary"></i> 
                                       {{store.country_code}} {{store.contact_no}}
                                    </p>
                                   
                                 </div>
                              </div>                              

                           </div>
                        </div>
                        <!-- end card -->     
                        <div class="d-grid gap-2">
                           <b-button v-b-modal.password-modal block variant="primary">Change Password</b-button>
                           
<!--                            <router-link :to="{ name: 'profile.edit', params: {id: $route.params.id} }" class="btn btn-primary">Edit Profile</router-link>  
 -->                        </div>

                        <b-card header-class="bg-transparent border-light" class="border border-light mt-3">                           
                           <div class="media">
                              <div class="avatar-sm align-self-center me-4 rounded-circle bg-primary">
                                 <span class="avatar-title">
                                    <i class="fas fa-shopping-cart font-size-24"></i>
                                 </span>
                              </div>
                              <div class="media-body">
                                 <p class="text-muted fw-medium mb-2">Orders</p>
                                 <h4 class="mb-0">{{no_of_orders}}</h4>
                              </div>                              
                           </div>
                        </b-card>
 
                        </div>

                     <div class="col-lg-7 col-md-7">
                        <b-card header-class="bg-transparent border-light" class="border border-light">
                           <h4 class="font-size-16 bg-light  border border-top-0 border-start-0 border-end-0 px-3 py-2 mb-3">Store Details</h4>
                              

                              <div class="table-responsive ">
                                 <table class="table table-nowrap mb-0">
                                    <tbody>
                                       <!-- <tr width="50%">
                                          <th scope="row">Patent ID</th>
                                          <th>:</th>
                                          <td>TRPT-123</td>
                                       </tr> -->
                                       <tr width="50%">
                                          <th scope="row">Latitude</th>
                                          <th>:</th>
                                          <td>{{store.latitude}}</td>
                                       </tr> 

                                       <tr>
                                          <th scope="row">Longitude</th>
                                          <th>:</th>
                                          <td>{{store.longitude}}</td>
                                       </tr>  

                                        <tr>
                                          <th scope="row">Address</th>
                                          <th>:</th>
                                          <td>{{store.address}}</td>
                                       </tr>   
                                        <tr>
                                          <th scope="row">State</th>
                                          <th>:</th>
                                          <td>{{store.states}}</td>
                                       </tr>   

                                       <tr>
                                          <th scope="row">Created on</th>
                                          <th>:</th>
                                          <td>{{store.created_at|formatDateTime}}</td>
                                       </tr>    
                                         
                                    </tbody>
                                 </table>
                              </div>
                           
                        </b-card>
                        <!-- end card -->

                        
                        <b-card header-class="bg-transparent border-light" class="border border-light mt-3" v-if="store.latitude && store.longitude">  
                           <h4 class="font-size-16 bg-light  border border-top-0 border-start-0 border-end-0 py-2 px-3 mb-3">Location</h4>
                           <b-row>                          

                              <b-col  md="12">
                                 <GmapMap v-if="store.latitude && store.longitude"
                                 :center="center"
                                 :zoom="18"
                                 map-style-id="roadmap"
                                 :options="mapOptions"
                                 style="width: 100%; height: 300px"
                                 ref="mapRef">                              
                                    <GmapMarker
                                       :position="marker.position"
                                       :clickable="false"
                                       :draggable="false"                                    
                                    />
                              </GmapMap>        
                              </b-col>

                           </b-row>
                        </b-card>

                        

                     </div>
                     
                  </div>
                  <!---- Details ends -------->

               </div>
            </div>
         </div>
      </div>

      <!---- modal starts ---->
      <b-modal ref="password-modal" id="password-modal" title="Change Password" hide-footer @hidden="clearForm()">
         <b-form @submit.prevent="updatePassword()">
            <b-row>  
              <b-col md="5" class="form-group">
                           <label class="control-label">Password</label>
                           <b-input-group>
                              <b-form-input type="password" v-model="password"  v-if="!show_password" v-bind:class="{ 'is-invalid': Boolean(errors.password) }"></b-form-input>
                              <b-form-input type="text" v-model="password" v-else v-bind:class="{ 'is-invalid': Boolean(errors.password) }"></b-form-input>
                              <b-input-group-text @click="togglePassword()">
                                 <i class="fas fa-eye" v-if="show_password"></i>
                                 <i class="fas fa-eye-slash" v-else></i>
                              </b-input-group-text>
                               
                               
                              <div v-for="(val, index) in errors.password" :key="index" class="invalid-feedback">
                                 <p class="mb-0">{{ val }}</p>
                              </div>
                           </b-input-group>
                           
                        </b-col>

                        <b-col md="5" class="form-group">
                           <label class="control-label">Confirm Password</label>
                           <b-input-group>
                                 <b-form-input type="password" v-model="password_confirmation" v-if="!show_confirm_password" v-bind:class="{ 'is-invalid': Boolean(errors.password_confirmation) }"></b-form-input>
                                 <b-form-input type="text" v-model="password_confirmation" v-bind:class="{ 'is-invalid': Boolean(errors.password_confirmation) }" v-else></b-form-input>
                                 <b-input-group-text @click="toggleConfirmPassword()">
                                    <i class="fas fa-eye" v-if="show_confirm_password"></i>
                                    <i class="fas fa-eye-slash" v-else></i>
                                 </b-input-group-text>

                                 <div v-for="(val, index) in errors.password_confirmation" :key="index" class="invalid-feedback">
                                    <p class="mb-0">{{ val }}</p>
                                 </div>                              
                           </b-input-group>
                        </b-col>

                         
               <b-col lg="12">
                  <b-button type="submit" class="me-3" variant="primary">Update</b-button>
                  <b-button class="" variant="light" @click="hideModal('password-modal')">Close</b-button>
               </b-col>
            </b-row>
         </b-form>
      </b-modal>
      <!---- modal ends ----->

      <!---- modal starts ---->
      <b-modal ref="token-modal" id="token-modal" title="Add Token" hide-footer>
         <b-form>
            <b-row>                          

               <b-col md="12" class="form-group">
                  <label class="control-label">Count<span class="required">*</span></label>
                  <b-form-input></b-form-input>
                  
               </b-col>                           
                           
               <b-col md="12">
                  <b-button type="submit" class="me-3" variant="primary">Save</b-button>
                  <b-button class="" variant="light" @click="hideModal('token-modal')">Close</b-button>
               </b-col>
            </b-row>
         </b-form>
      </b-modal>
      <!---- modal ends ----->
   </Layout>
</template>
